import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, delay, filter, map, of, tap } from 'rxjs';
import { ProposalStepActions } from '@lockton-apps/proposals/action';
import { FeedbackService } from '@lockton-apps/shared/ui/lui';
import { QuotesApiActions } from '@lockton-apps/shared/action/quotes';
import { QuoteEffectsActions } from '@lockton-apps/shared/data-access/quotes';
import {
  FeedbackMessage,
  FeedbackMessagesService,
} from '../services/feedback-messages.service';

@Injectable()
export class FeedbackMessagesEffects {
  constructor(
    private actions$: Actions,
    private feedbackService: FeedbackService,
    private feedbackMessagesService: FeedbackMessagesService
  ) {}

  feedbackMessages$ = createEffect(
    () =>
      this.actions$
        .pipe(
          ofType(
            // Proposals
            ProposalStepActions.connectionLost,
            ProposalStepActions.connectionRestored,

            // Quotes
            QuotesApiActions.sendRenewalInviteSuccess,
            QuotesApiActions.proposalSubmittedSuccess,
            QuotesApiActions.quoteRequestedSuccess,
            QuotesApiActions.quoteReadySuccess,
            QuotesApiActions.sendToClientSuccess,
            QuotesApiActions.acceptSuccess,
            QuotesApiActions.notTakenUpSuccess,
            QuotesApiActions.invoiceSuccess,
            QuotesApiActions.completeSuccess,
            QuotesApiActions.proposalUpdatedSuccess,
            QuotesApiActions.proposalUpdatedFailure,
            QuotesApiActions.proposalAutoSavedSuccess,
            QuotesApiActions.proposalAutoSavedFailure,
            QuotesApiActions.endorsementsUpdatedSuccess,
            QuotesApiActions.endorsementsUpdatedFailure,
            QuoteEffectsActions.proposalBackupSaved
          )
        )
        .pipe(
          map(({ quote, type }: any) =>
            this.feedbackMessagesService.getMessageFor(
              type,
              quote?.portalId,
              quote
            )
          ),
          filter(Boolean),
          concatMap((message: FeedbackMessage) =>
            of(message).pipe(delay(message.delay))
          ),
          tap(({ text, type }) => {
            this.feedbackService.subtleMessage(text, { type });
          })
        ),
    { dispatch: false }
  );
}
